import { useState, useEffect, useRef } from "react";
import styles from "./dropdownfilter.module.css";
import DropDownIcon from "../Icons/DropDownIcon";

const DropdownCustomDate = ({
	options,
	defaultOption,
	onSelect,
	selectedLabel,
	dropdownClass,
	placeholder = "Select an option",
	placeholderClass = styles.placeholder,
	dropdownToggleClass,
	scrollToValue = null // Value to scroll to when dropdown opens
}) => {
	const [selectedOption, setSelectedOption] = useState(defaultOption);
	const [isDropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);
	const dropdownMenuRef = useRef(null);
	useEffect(() => {
		setSelectedOption(selectedLabel || defaultOption);
	}, [selectedLabel, defaultOption]);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	// Auto-scroll dropdown into view inside scrollable parent
	useEffect(() => {
		if (isDropdownOpen && dropdownMenuRef.current) {
			dropdownMenuRef.current.scrollIntoView({
				behavior: "smooth",
				block: "nearest",
			});

			// Scroll to specific value if provided
			if (scrollToValue !== null) {
				const scrollToIndex = options.findIndex(opt => opt.value === scrollToValue);
				if (scrollToIndex !== -1) {
					// Use setTimeout to ensure the DOM is ready
					setTimeout(() => {
						const items = dropdownMenuRef.current?.querySelectorAll('.dropdownItem');
						if (items && items[scrollToIndex]) {
							items[scrollToIndex].scrollIntoView({
								behavior: "instant",
								block: "center",
							});
						}
					}, 0);
				}
			}
		}
	}, [isDropdownOpen, scrollToValue, options]);

	const handleSelect = (option) => {
		if (option === "Select reason") return;
		setSelectedOption(option);
		onSelect(option);
		setDropdownOpen(false);
	};
	const displayOption = selectedOption || placeholder;

	return (
		<div
			ref={dropdownRef}
			className={`${dropdownClass} commonDropdownNoImage`}
			tabIndex={0}>
			<div className={`dropdownToggle ${dropdownToggleClass} ${!selectedLabel ? placeholderClass : ""}`}
				onClick={() => setDropdownOpen(!isDropdownOpen)}>
				{displayOption}
				<div className={`${styles.arrow} ${isDropdownOpen ? styles.up : ''}`}>
					<DropDownIcon/>
				</div>
			</div>
			{isDropdownOpen && (
				<ul className="dropdownMenu" ref={dropdownMenuRef}>
					{options.map((option, index) => {
						return (
							<li
								key={index}
								className="dropdownItem"
								onClick={() => handleSelect(option.text)}
							>
								{option.text}
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
};

export default DropdownCustomDate;
